import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Typography from '@mui/material/Typography';

import { Header } from '../../../components/singleComponents/headers';
import { SearchAndFilter } from './components/SearchAndFilter';
import { TableFeedbacks } from './components/TableFeedbacks';

import { RootStyled, TitleContainer, TicketsBtn } from './supportAdmin.styles';

export function SupportAdmin() {
  const { id: userId } = JSON.parse(localStorage.getItem('user'));
  const navigate = useNavigate();

  const [searchValue, setSearchValue] = useState('');
  const [filterOptions, setFilterOptions] = useState({
    read: '',
    date: '',
    order: '',
  });

  return (
    <>
      <Header page="Suporte" />
      <RootStyled>
        <TitleContainer>
          <Typography component="h2" variant="h2">
            Seus Tickets
          </Typography>
          {[1, 164].includes(userId) && (
            <SearchAndFilter
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              filterOptions={filterOptions}
              setFilterOptions={setFilterOptions}
            />
          )}
          {![1, 164].includes(userId) && (
            <TicketsBtn
              variant="contained"
              onClick={() => navigate('/new-ticket')}
            >
              Abrir novo ticket
            </TicketsBtn>
          )}
        </TitleContainer>
        <TableFeedbacks
          searchValue={searchValue}
          filterOptions={filterOptions}
        />
      </RootStyled>
    </>
  );
}
